(function(angular){
	'use strict';
	
	angular
		.module('assetsModule', [
			'apiModule',
			'coreModule',
			'goalTeaserModule',
			'planModule',
			'reitElementListingModule'
		]);

})(window.angular);